/**
 * Serviço de Salas
 *
 * Gerencia operações CRUD de salas usando PostgREST.
 */

import { postgrestClient } from "../lib/postgrest/client";

/**
 * Serviço de salas
 */
export const salasService = {
  /**
   * Lista salas com filtros
   * @param {Object} options
   * @param {Object} options.filters - Filtros (ex: { nucleo_id: "eq.123" })
   * @param {string} options.order - Ordenação (ex: "identificador.asc")
   * @param {number} options.limit - Limite de resultados
   * @param {number} options.offset - Offset para paginação
   * @returns {Promise<Array>}
   */
  async list(options = {}) {
    const { filters = {}, order = "identificador.asc", limit, offset } = options;
    return postgrestClient.get("sala", {
      filters,
      order,
      limit,
      offset,
    });
  },

  /**
   * Busca sala por ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  async getById(id) {
    const result = await postgrestClient.get("sala", {
      filters: { sala_id: `eq.${id}` },
    });
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Cria nova sala
   * @param {Object} salaData
   * @returns {Promise<Object>}
   */
  async create(salaData) {
    const result = await postgrestClient.post("sala", salaData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Atualiza sala
   * @param {string} id
   * @param {Object} salaData
   * @returns {Promise<Object>}
   */
  async update(id, salaData) {
    const result = await postgrestClient.patch("sala", { sala_id: id }, salaData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Remove sala
   * @param {string} id
   * @returns {Promise<null>}
   */
  async delete(id) {
    return postgrestClient.delete("sala", { sala_id: id });
  },

  /**
   * Busca salas de um núcleo
   * @param {string} nucleoId
   * @param {Object} options - Opções de paginação
   * @returns {Promise<Array>}
   */
  async getByNucleo(nucleoId, options = {}) {
    return this.list({
      filters: { nucleo_id: `eq.${nucleoId}` },
      ...options,
    });
  },
};

export default salasService;

